const API_SPEC_FIELD_TYPES = {
    array: 'array',
    boolean: 'boolean',
    date: 'date',
    datetime: 'datetime',
    integer: 'integer',
    monetary: 'monetary',
    number: 'number',
    string: 'string',
};

export default API_SPEC_FIELD_TYPES;
